import { type TaskPriority } from "@crowdcoursing/api/openapi";

export const PRIORITY_COLORS: Record<TaskPriority, string> = {
  1: "#d32f2f", // Urgent - Deeper red
  2: "#f57c00", // High - Orange
  3: "warning.main", // Medium - Yellow
  4: "primary.main", // Low - Primary color
} as const;

export const PRIORITY_LABELS: Record<TaskPriority, string> = {
  1: "Urgent",
  2: "High",
  3: "Medium",
  4: "Low",
} as const;
